import clsx from 'clsx'
import React, { FC } from 'react'

import { ImageV3 } from '@Components/Image'

import styles from './NecklaceOption.module.scss'

const NecklaceImages = {
  '35cm': 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt301df2e172a2dadb/35cm-ID-20353.jpg',
  '40cm': 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/bltcfa6dfc6541639d9/40cm-ID-20352.jpg',
  '45cm': 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt2b1b99fcd9f2731f/45cm-ID-20347.jpg',
  '50cm': 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blte05fc13e9f785a5f/50cm-ID-15174.jpg',
  '55cm': 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/bltd04398cad3528687/55cm-ID-15175.jpg',
  '60cm': 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt80494b12fd747ddb/60cm-ID-15176.jpg',
  '65cm': 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/bltdd02b880db18811d/65cm-ID-15177.jpg',
}

interface NecklaceOptionProps {
  disabled?: boolean
  size: string
}

export const NecklaceOption: FC<NecklaceOptionProps> = ({
  disabled,
  size,
}) => (
  <ImageV3
    alt={size}
    className={clsx(styles.image, disabled && styles.disabled)}
    draggable={false}
    height={66}
    src={NecklaceImages[size]}
    width={100}
  />
)
